import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { notify } from 'libs/common';
import { path } from 'router/sections';
import { user } from 'services';
import { getClientType, getClientBalance } from 'services/client-service';
import { Button, GradientButton, themes } from 'libs/ui';
import { TopupForm } from './client/forms/topup-form';
import { ClientActivity } from './client-activity';
import { Content, ProfileInfo, Name, Type, AccountLink, Amount, Left, Right } from './client-profile.styled';

let timer1;

export const ClientProfile = (props) => {
  const history = useHistory();
  const { client, refreshClient } = props;
  const [showTopup, setShowTopup] = useState(false);
  const [balance, setBalance] = useState(null);
  const [n, setN] = useState(false);
  const { t } = useTranslation();

  // clean
  useEffect(() => {
    return () => {
      if (timer1) {
        clearTimeout(timer1);
      }
    };
  }, []);

  // get balance
  useEffect(() => {
    const getData = async () => {
      await getClientBalance(client.id)
        .then((data) => setBalance(data))
        .catch((error) => notify('Получение баланса', error.toString()));
    };
    getData();
  }, [n]);

  /**
   * show topup
   */
  const showTopupForm = () => {
    setShowTopup(true);
  };

  /**
   * hide topup
   */
  const hideTopupForm = () => {
    setShowTopup(false);
  };

  /**
   * to stay card
   */
  const toClientStays = () => {
    history.push(path('stays'), {
      filter: {
        client_name: client.name,
      },
    });
  };

  /**
   * refresh client balance
   */
  const refreshBalance = () => {
    setN((n) => !n);
    timer1 = setTimeout(() => hideTopupForm(), 200);
  };

  const rightStaysList = user.haveRight('stays.list');
  const rightTopup = user.haveRight('clients.replenish');
  const withoutBalance = user.inInterface('clients_balance');
  const clientTypeTitle = getClientType(client.type);

  return (
    <>
      <Content>
        <img width={100} src={`/images/${client.type}.png`} alt="" />
        <ProfileInfo>
          <Name>{client.name}</Name>
          <Type>{t(clientTypeTitle)}</Type>
          <AccountLink>
            <Left>
              <Amount>
                {t('form.Лицевой счет')}: {client.account_id || t('form.Не известно')}
              </Amount>

              {!withoutBalance && balance && (balance.balance || balance.balance === 0) && (
                <>
                  <Amount>
                    {t('form.Баланс')}: {`${balance.balance / 100} ${t('grid.₽')}`}
                  </Amount>
                  {rightTopup && (
                    <Amount>
                      <Button onClick={showTopupForm} theme={themes.blue}>
                        {t('buttons.Корректировка баланса')}
                      </Button>
                    </Amount>
                  )}
                </>
              )}
            </Left>
            <Right>
              {rightStaysList && (
                <GradientButton theme={themes.darkGradient} onClick={toClientStays}>
                  {t('buttons.Перейти в парковки')}
                </GradientButton>
              )}
            </Right>
          </AccountLink>
        </ProfileInfo>
        <ClientActivity client={client} refresh={refreshClient} />
      </Content>
      {showTopup && <TopupForm close={hideTopupForm} refresh={refreshBalance} balance={balance} />}
    </>
  );
};
